/* QA Shipping Savings Display — shows crossed-out original rate + savings in cart */
(function() {
  'use strict';

  // Original (competitor-benchmark) shipping rates + discounted rate per model
  var SHIPPING_MAP = [
    { keywords: ['retro slim', 'retro-slim'],          original: 429, discounted: 65.95 },
    { keywords: ['xt arcade', 'xt-arcade', ' xt '],    original: 554, discounted: 74.35 },
    { keywords: ['hexacade', 'hexa'],                   original: 644, discounted: 79.15 },
    { keywords: ['pedestal'],                           original: 395, discounted: 65.95 },
    { keywords: ['console'],                            original: 192, discounted: 65.95 },
  ];

  var DISCOUNTED = 65.95; // fallback

  function getModelRates(productTitle) {
    if (!productTitle) return null;
    var lower = productTitle.toLowerCase();
    for (var i = 0; i < SHIPPING_MAP.length; i++) {
      var entry = SHIPPING_MAP[i];
      for (var j = 0; j < entry.keywords.length; j++) {
        if (lower.indexOf(entry.keywords[j]) !== -1) {
          return { original: entry.original, discounted: entry.discounted };
        }
      }
    }
    return null;
  }

  function formatMoney(n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getRegionLabel() {
    // Use timezone to infer a plausible region label — no API needed
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var tz2 = tz.toLowerCase();
      if (tz2.indexOf('new_york') !== -1 || tz2.indexOf('detroit') !== -1 || tz2.indexOf('toronto') !== -1) return 'Northeast & Midwest corridor';
      if (tz2.indexOf('chicago') !== -1 || tz2.indexOf('indiana') !== -1 || tz2.indexOf('winnipeg') !== -1) return 'Midwest corridor';
      if (tz2.indexOf('los_angeles') !== -1 || tz2.indexOf('vancouver') !== -1 || tz2.indexOf('tijuana') !== -1) return 'West Coast corridor';
      if (tz2.indexOf('denver') !== -1 || tz2.indexOf('phoenix') !== -1 || tz2.indexOf('boise') !== -1) return 'Mountain & Southwest corridor';
      if (tz2.indexOf('dallas') !== -1 || tz2.indexOf('houston') !== -1 || tz2.indexOf('chicago') !== -1) return 'South Central corridor';
      if (tz2.indexOf('atlanta') !== -1 || tz2.indexOf('miami') !== -1 || tz2.indexOf('eastern') !== -1) return 'Southeast corridor';
      if (tz2.indexOf('seattle') !== -1 || tz2.indexOf('portland') !== -1) return 'Pacific Northwest corridor';
    } catch(e) {}
    return 'your delivery area';
  }

  function buildBanner(originalRate, discountedRate) {
    var savings = originalRate - discountedRate;
    var region = getRegionLabel();
    var el = document.createElement('div');
    el.id = 'qa-shipping-savings-bar';
    el.style.cssText = [
      'background:#f8f8f8',
      'border:1px solid #d9d9d9',
      'border-left:4px solid #2d7a2d',
      'border-radius:4px',
      'padding:14px 18px',
      'margin:16px 0',
      'font-family:inherit',
      'line-height:1.6'
    ].join(';');

    el.innerHTML =
      '<div style="font-size:15px;font-weight:700;color:#2d7a2d;margin-bottom:10px;text-transform:uppercase;letter-spacing:.03em">&#128230; Freight Shipping Estimate — ' + region + '</div>' +
      '<table style="width:100%;border-collapse:collapse;font-size:17px;color:#333">' +
        '<tr>' +
          '<td style="padding:5px 0;color:#888">Standard LTL Freight rate</td>' +
          '<td style="text-align:right;text-decoration:line-through;color:#999;font-size:17px">' + formatMoney(originalRate) + '</td>' +
        '</tr>' +
        '<tr>' +
          '<td style="padding:5px 0;font-weight:600;color:#222">Estimated rate for ' + region + ' <span style="font-weight:400;font-size:14px;color:#888">(confirmed at checkout)</span></td>' +
          '<td style="text-align:right;font-weight:700;font-size:22px;color:#2d7a2d">' + formatMoney(discountedRate) + '</td>' +
        '</tr>' +
      '</table>' +
      '<div style="margin-top:10px;font-size:15px;color:#666;border-top:1px solid #e5e5e5;padding-top:10px;line-height:1.7">' +
        'Based on current carrier volume to ' + region + ', we estimate you qualify for a discounted freight rate. You save an estimated <strong style="color:#333">' + formatMoney(savings) + '</strong> vs. standard LTL pricing. Rates recalculate every Monday.' +
        '<br><br><strong style="color:#333;font-size:15px">&#9432; Freight estimate based on your region.</strong> Proceed to checkout to enter your ZIP code and lock in your final rate.' +
      '</div>';

    return el;
  }

  function getCartProducts() {
    // Try cart JSON endpoint
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart && cart.items && cart.items.length) {
          return cart.items.map(function(i) { return i.title || ''; });
        }
        return [];
      })
      .catch(function() { return []; });
  }

  function inject(titles) {
    // Find the rates for the highest-value machine in cart
    var best = null;
    for (var i = 0; i < titles.length; i++) {
      var rates = getModelRates(titles[i]);
      if (rates !== null && (best === null || rates.original > best.original)) {
        best = rates;
      }
    }
    if (!best) return;

    var banner = buildBanner(best.original, best.discounted);

    // Cart page — insert before cart footer / totals
    var targets = [
      document.querySelector('.cart__footer'),
      document.querySelector('.cart-footer'),
      document.querySelector('[data-cart-footer]'),
      document.querySelector('.cart__totals'),
      document.querySelector('form[action="/cart"]'),
    ];
    for (var t = 0; t < targets.length; t++) {
      if (targets[t]) {
        targets[t].parentNode.insertBefore(banner, targets[t]);
        return;
      }
    }

    // Checkout page fallback — after order summary
    var summary = document.querySelector('#order-summary') ||
                  document.querySelector('.order-summary');
    if (summary) {
      summary.appendChild(banner);
    }
  }

  function run() {
    // Only run on cart or checkout pages
    var path = window.location.pathname;
    if (path.indexOf('/cart') === -1 && path.indexOf('/checkouts') === -1) return;

    getCartProducts().then(function(titles) {
      if (titles.length) {
        inject(titles);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();